import { Box, Flex, Input, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import SvgContainer from "src/components/SvgContainer";
import { ReactComponent as CameraIcon } from "src/icons/camera-outlined.svg";
import environment from "src/utils/environment";

export default function PhotoPicker({ onChange }) {
  const { t } = useTranslation();
  return (
    <Flex
      direction="column"
      align="center"
      rowGap="6px"
      pos="relative"
      _hover={{ cursor: "pointer" }}
      onClick={environment.isBrowser ? undefined : onChange}
    >
      {environment.isBrowser && (
        <Box position="absolute" w="100%" h="100%" top="0" left="0">
          <Box
            as="label"
            htmlFor="file-upload"
            display="inline-block"
            w="100%"
            h="100%"
            opacity="0"
            _hover={{ cursor: "pointer" }}
          />
          <Input
            onChange={onChange}
            id="file-upload"
            type="file"
            accept="image/png, image/jpeg"
            display="none"
          />
        </Box>
      )}
      <Text fontSize="12px" fontWeight={600} color="primary">
        {t("select.photo")}
      </Text>
      <SvgContainer icon={CameraIcon} fill="primary" />
    </Flex>
  );
}
